import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

// hammer configuration (usefull to fix scroll problem with onSwipe)
@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    pinch: { enable: false },
    rotate: { enable: false },
    swipe: { direction: Hammer.DIRECTION_ALL },
  } as any;
}
